import { render, staticRenderFns } from "./sidebarconfigurationcontent.vue?vue&type=template&id=02aa2a28&scoped=true"
import script from "./sidebarconfigurationcontent.vue?vue&type=script&lang=js"
export * from "./sidebarconfigurationcontent.vue?vue&type=script&lang=js"
import style0 from "./sidebarconfigurationcontent.vue?vue&type=style&index=0&id=02aa2a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02aa2a28",
  null
  
)

export default component.exports